
import { 
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline, 
	hasPermissions,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud
} from '@/router/index'



import Machinery from '@/components/modules/banci/Machinery'
import ProductionManager from '@/components/modules/banci/ProductionManager'
import ProductionOptions from '@/components/modules/banci/settings/ProductionOptions'

export const banci = [
	{
		path: '/looms',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/looms/',
					text: 'Telai',
				},      
			],
		},
		children: [
			{
				path: '/looms/',
				name: 'looms-index',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: {
					modelDef: 'looms',
					actionIcon: 'tune',
					title: 'Telai',
				}
			},		
		],
	},
	{
		path: '/looms/create',
		name: 'looms-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'looms',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/looms/:id/edit',
		name: 'looms-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'looms',
			id: parseInt(route.params.id),
		}),
	},
	{ 
		path: '/looms/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/looms/' + parseInt(route.params.id) + '/',
					text: 'Telaio',
				},
			],
		}),		
		children: [
			{
				path: '',
				name: 'looms-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Telaio'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'looms',
					modelClass: 'loom',
					activities: true,
				}), 
			},
		]
	},
	{
		path: '/machines',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/machines/',
					text: 'Macchinari',
				},
				{
					to: '/machineprocesses',
					text: 'Lavorazioni',
				},      
			],
		},
		children: [
			{
				path: '/machines/',
				beforeEnter: ifAuthenticatedOnline,
				component: Machinery,
			},
			{
				path: '/machineprocesses',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: {
					modelDef: 'machineprocesses',
					actionIcon: 'precision_manufacturing',
					title: 'Lavorazioni Macchinari',
					crudDialog: true
				}
			},		
		],
	},	
	{
		path: '/production/',
		beforeEnter: ifAuthenticatedOnline,
		component: ProductionManager,
		props: {
			modelDef: 'production',
			actionIcon: 'assignment_turned_in',
			title: 'Produzione'
		}
	},
	{
		path: '/production/manager',
		beforeEnter: (to, from, next) => { hasPermissions('productionmanager', next) },
		component: ProductionManager,
		props: {
			modelDef: 'productionmanager',
			actionIcon: 'assignment_turned_in',
			title: 'Manager'
		}
	},
	{
		path: '/settingslooms/',
		name: 'settingslooms',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingslooms/',
					text: 'Generali',
				},
			],
		},
		children: [	
			{
				path: '/settingslooms/',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: {
					modelDef: 'generaltypes-loom_zone',
					actionIcon: 'settings',
					title: 'Zone telai',
					actionPosition: 'absolute',
					crudDialog: true
				}
			},
		],
	},
	{
		path: '/settingsproduction/',
		name: 'settingsproduction',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsproduction/',
					text: 'Produzione',
				},
			],
		},
		children: [	
			{
				path: '/settingsproduction/',
				beforeEnter: ifAuthenticatedOnline,
				component: ProductionOptions,
			},
		],
	},
]